@if (shouldShowBlock) {
    <br />
    <checkout-select-choice
        (onChoice)="onChoiceChange($event)"
        [cartForm]="cartForm"
        [isMobile]="isMobile"
        [isCompatiblePromoFoyer]="isCompatiblePromoFoyer"
    />

    @if (cartForm.get('mixed-choice')?.get('choiceControl')?.value === true) {
        <div>
            <br />
            <div checkoutCy="fai-widget-bloc">
                <checkout-fai-elig-widget [params]="widgetFaiEligParams"></checkout-fai-elig-widget>
            </div>
        </div>
    }
}
